<template>
  <div class="crm-follow-add">
    <el-form :model="addParams" :rules="rules" ref="addForm">
      <el-form-item label="" :show-message="false" prop="content" class="follow-content" v-if="targetType != 'business' && targetType != 'contract'&& targetType != 'deliveryOrder' && targetType != 'serviceOrder'">
        <el-input type="textarea"
          :autosize="{ minRows: 5, maxRows: 8}"
          placeholder="1、跟进情况描述 2、存在的问题与风险 3、跟进的策略 4、下一步行动计划和目标5、所需的资源"
          :maxlength="1000"
          show-word-limit
          v-model="addParams.content">
        </el-input>
      </el-form-item>
      <At v-else :members="members" name-key="nickName">
        <template slot="item" slot-scope="s">
          <span v-text="s.item.nickName"></span>
        </template>
        <div class="msg-box">
          <div
            id="info"
            :class="['msgInfo', { 'simple-msg-info': simpleMode }]"
            ref="info"
            contenteditable
            @input="syncContentFromEditor">
          </div>
          <p class="word-number"><span
            :style="addParams.content.length > 1000 ? 'color: red' : ''">{{ addParams.content.length }}</span> / 1000
          </p>
        </div>
      </At>
      <div v-if="simpleMode" class="simple-follow-actions">
        <el-form-item prop="fileObjs" class="simple-file-form">
          <FileUpload
            class="simple-file-upload"
            v-model="addParams.fileObjs"
            :limit="5"
            :readOnly="false"
            @on-change="handleFileChange">
          </FileUpload>
        </el-form-item>
        <el-button type="primary" icon="el-icon-edit" @click="addFollow" :disabled="submitDisabled">保存进展</el-button>
      </div>
      <el-row v-else>
        <el-col :xs="24" :md="12" :lg="12">
          <el-form-item prop="fileObjs">
            <el-popover placement="bottom-start" title="上传附件" trigger="click">
              <el-badge slot="reference" :value="addParams.fileObjs.length" :hidden="addParams.fileObjs.length <= 0"
                        type="primary">
                <el-button plain icon="el-icon-paperclip">附件</el-button>
              </el-badge>
              <FileUpload v-model="addParams.fileObjs" :limit="5" :readOnly="false"
                          @on-change="handleFileChange"></FileUpload>
            </el-popover>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="5" :lg="5" align="right">
          <el-form-item prop="followType">
            <el-select v-model="addParams.followType" filterable placeholder="请选择跟进类型"
                       style="margin-right:25px;">
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="4" :lg="4" align="right">
          <el-form-item prop="followContactId">
            <el-select v-model="addParams.followContactId" filterable clearable placeholder="请选择联系人" @visible-change="queryContactList" style="margin-right:5px;">
              <el-option v-for="item in contactList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="3" :lg="3" align="right">
          <el-button type="primary" icon="el-icon-edit" style="vertical-align: top;" @click="addFollow"
                     :disabled="submitDisabled">跟进
          </el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import {transferCascaderOptions} from "@/utils";
import {createFollow, queryAtList} from "@/api/crm/follow";
import {contactListSimple} from "@/api/crm/contact";
import FileUpload from "@/views/crm/components/fileUpload";
import At from 'vue-at'

export default {
  name: "followAdd",
  props: {
    targetId: {},
    targetType: {},
    businessStageCode: {
      type: String,
      default: null
    },
    contractPhaseId: {
      default: null
    },
    simpleMode: {
      type: Boolean,
      default: false
    },
    simpleFollowType: {
      type: String,
      default: '阶段进展'
    },
  },
  data () {
    return {
      members: [],
      typeOptions: [],
      contactList: [],
      list: [],
      rules: {
        content: [
          {required: true, validator: this.validContent, message: '请输入内容', trigger: 'change'},
          {max: 1000, message: '长度过长', trigger: 'change'}
        ],
        followType: [
          {required: true, validator: this.validType, message: '请选择', trigger: 'change'}
        ]
      },
      addParams: {
        targetId: null,
        targetType: null,
        followType: null,
        followContactId: null,
        content: "",
        fileObjs: [],
        businessStageCode: null,
        contractPhaseId: null
      }
    };
  },
  components: {
    FileUpload,
    At
  },
  mounted () {
    this.addParams.targetId = this.targetId;
    this.addParams.targetType = this.targetType;
    this.addParams.businessStageCode = this.businessStageCode;
    this.addParams.contractPhaseId = this.contractPhaseId;
    this.syncSimpleFollowType();
    // 查询跟进类型 v1.1.0版本去掉了二级类型
    this.getDicts("follow_type").then(response => {
      this.typeOptions = transferCascaderOptions(response.data, "dictValue", "dictLabel");
    });
    console.log('this.targetType', this.targetType)
    if (this.targetType == 'business' || this.targetType == 'contract' || this.targetType == 'deliveryOrder' || this.targetType == 'serviceOrder' ) {
      this.queryAtList()
      setInterval(() => {
        if (document.getElementById('info')) {
          let content = document.getElementById('info').innerText
          if (this.addParams.content != content) {
            this.addParams.content = content
            console.log('content', content)
          }
        }
      }, 100)
    }
  },
  watch: {
    targetId (val) {
      this.addParams.targetId = this.targetId;
      if (!val) {
        this.addParams.content = "";
        this.addParams.fileObjs = [];
        this.resetForm("addForm");
        this.syncSimpleFollowType();
      }
    },
    targetType (val) {
      this.addParams.targetType = this.targetType;
    },
    businessStageCode (val) {
      this.addParams.businessStageCode = this.businessStageCode;
    },
    contractPhaseId (val) {
      this.addParams.contractPhaseId = this.contractPhaseId;
    },
    simpleMode () {
      this.syncSimpleFollowType();
    }
  },
  computed: {
    submitDisabled () {
      if (!this.targetId || !this.targetType) {
        return true
      }
      if (this.simpleMode) {
        return !String(this.addParams.content || '').trim() && this.addParams.fileObjs.length <= 0
      }
      return this.addParams.content.length <= 0
    }
  },
  methods: {
    syncContentFromEditor () {
      if (this.$refs.info) {
        const content = this.$refs.info.innerText || ''
        if (this.addParams.content !== content) {
          this.addParams.content = content
        }
      }
    },
    syncSimpleFollowType () {
      if (this.simpleMode) {
        this.addParams.followType = this.simpleFollowType;
      }
    },
    // 查询@人员列表
    queryAtList () {
      queryAtList({
        targetId: this.targetId,
        targetType: this.targetType,
      }).then(response => {
        this.members = response.data || []
      })
    },
    queryContactList (visible) {
      if (visible) {
        contactListSimple(this.addParams).then(response => {
          this.contactList = response.data
        })
      }
    },
    handleFileChange (fileObjs) {
      this.addParams.fileObjs = fileObjs;
    },
    validContent (rule, value, callback) {
      if (this.simpleMode && this.addParams.fileObjs.length > 0) {
        callback()
        return
      }
      if (String(value || '').trim()) {
        callback()
      } else {
        callback(new Error("请输入内容"))
      }
    },
    validType (rule, value, callback) {
      if (this.simpleMode) {
        callback()
        return
      }
      // 必填
      if (value && value.length > 0 && value[0]) {
        callback()
      } else {
        callback(new Error("请输入"))
      }
    },
    addFollow () {
      this.syncContentFromEditor();
      if (this.addParams.content.length > 1000) {
        this.msgWarning("跟进文本输入过长！");
        return
      }
      this.syncSimpleFollowType();
      if (!this.simpleMode && (this.addParams.targetType === 'customer' || this.addParams.targetType === 'clue'
        || this.addParams.targetType === 'business')) {
        if (!this.addParams.followContactId) {
          this.msgWarning("请选择跟进联系人");
          return
        }
      }
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          let params = JSON.parse(JSON.stringify(this.addParams));
          if (params.fileObjs && params.fileObjs.length > 0) {
            params.fileObjs = params.fileObjs.map(item => {
              return {id: item.id};
            })
          }
          params.contentType = 1 // 默认为字符串类型
          if (!this.simpleMode && (this.targetType == 'business' || this.targetType == 'contract'|| this.targetType == 'deliveryOrder' || this.targetType == 'serviceOrder')) {
            const stringList = this.addParams.content.split(" ")
            console.log('stringList', stringList)
            let infoList = stringList.reduce((result, item) => {
              if (item.length) {
                if (item.indexOf('@') > -1) {
                  let userNameList = item.split("@")
                  new Set(userNameList).forEach(userName => {
                    let index = this.members.findIndex(user => user.nickName === userName)
                    if (index > -1) {
                      let user = this.members[index]
                      result.push({
                        type: 1,
                        atUser: {
                          userId: user.userId,
                          nickName: user.nickName
                        }
                      })
                    } else {
                      if (userName.length) {
                        result.push({
                          type: 2,
                          content: userName
                        })
                      }
                    }
                  })
                } else {
                  result.push({
                    type: 2,
                    content: item
                  })
                }
              }
              return result
            }, [])
            console.log('infoList', infoList)
            params.content = JSON.stringify(infoList)
            params.contentType = 2 // 字符串类型
          }

          createFollow(params).then(response => {
            document.getElementById('info') ? document.getElementById('info').innerText = '' : ''
            this.addParams.content = ""
            this.addParams.fileObjs = []
            this.addParams.followContactId = null
            this.resetForm("addForm");
            this.syncSimpleFollowType();
            this.$emit('success');
            this.msgSuccess("填写记录成功");
            loading.close();
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>

<style lang='scss'>
.crm-follow-add {
  padding: 0 15px 15px 15px;

  .follow-content {
    margin-bottom: 9px !important;
  }

  .simple-follow-actions {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: flex-start;
    column-gap: 24px;
  }

  .simple-file-form {
    margin-bottom: 0;
  }

  .simple-file-upload {
    .el-upload__tip {
      display: none;
    }
  }
}

.msg-box {
  position: relative;

  .msgInfo {
    width: 100%;
    height: 150px;
    border: 1px solid #aaa;
    border-radius: 6px;
    padding: 5px 10px 20px;
    line-height: 2;
    white-space: pre-wrap;
    margin-bottom: 10px;
    overflow: auto;
  }

  .word-number {
    position: absolute;
    bottom: 2px;
    right: 20px;
    margin: 0;
    background: #fff;
  }
  // content: '1、跟进情况描述 2、存在的问题与风险 3、跟进的策略 4、下一步行动计划和目标 5、所需的资源';
  .msgInfo:empty:before {
    content: '\0031\3001\8ddf\8fdb\60c5\51b5\63cf\8ff0\0020\0032\3001\5b58\5728\7684\95ee\9898\4e0e\98ce\9669\0020\0033\3001\8ddf\8fdb\7684\7b56\7565\0020\0034\3001\4e0b\4e00\6b65\884c\52a8\8ba1\5212\548c\76ee\6807\0020\0035\3001\6240\9700\7684\8d44\6e90';
    font-size: 14px;
    color: #bebec3;
  }

  .msgInfo.simple-msg-info:empty:before {
    content: '\8bf7\8f93\5165\9636\6bb5\8fdb\5c55\ff0c\53ef\4e0a\4f20\9644\4ef6';
  }

  .msgInfo:focus:before {
    content: none;
  }
}

.atwho-view {
  top: 1.6em !important;
  left: 0 !important;
  bottom: unset !important;
}

</style>
